{
  "status": {
    "pending_verification": "รอ 本人確認",
    "active": "ใช้งาน",
    "suspended": "พักไว้",
    "closed": "ปิดแล้ว"
  },
  "columns": {
    "reference": "เลขที่",
    "name": "ชื่อ",
    "kyc": "本人確認",
    "items": "การ์ดที่ฝากอยู่",
    "awaiting": "ค้างจ่าย",
    "payout": "รับเงินทาง",
    "no_account": "ยังไม่มีบัญชี",
    "status": "สถานะ"
  },
  "filters": {
    "q": "ค้นหา",
    "q_placeholder": "ชื่อ คานะ เลข CON- หรืออีเมล"
  },
  "views": {
    "not_verified": "ยังไม่ผ่าน 本人確認"
  },
  "list": {
    "intro": "คนที่ฝากการ์ดให้ร้านขาย ต้องทำ 本人確認 (古物営業法) ก่อนรับการ์ด",
    "create": "ผู้ฝากใหม่"
  },
  "locales": {
    "en": "English",
    "ja": "日本語",
    "th": "ไทย",
    "zh_Hant": "繁體中文",
    "zh_Hans": "简体中文"
  },
  "payout": {
    "bank_transfer": "โอนเข้าบัญชี",
    "cash": "เงินสดที่ร้าน",
    "store_credit": "เครดิตร้าน",
    "stripe_connect": "จ่ายออนไลน์"
  },
  "fee": {
    "shop_absorbs": "ร้านรับค่าธรรมเนียมบัตร",
    "consignor_pro_rata": "ผู้ฝากรับค่าธรรมเนียมบัตรตามสัดส่วน",
    "split_50_50": "คนละครึ่ง"
  },
  "fee_help": {
    "shop_absorbs": "ผู้ฝากได้ราคาหักค่าคอม ไม่ว่าผู้ซื้อจ่ายด้วยวิธีไหน",
    "consignor_pro_rata": "เมื่อผู้ซื้อจ่ายด้วยบัตร ค่าธรรมเนียมบัตรของชิ้นนั้นจะหักจากยอดจ่ายผู้ฝาก",
    "split_50_50": "ค่าธรรมเนียมบัตรแบ่งครึ่ง: ร้านครึ่งหนึ่ง หักจากยอดจ่ายครึ่งหนึ่ง"
  },
  "schedule": {
    "monthly": "เดือนละครั้ง",
    "on_request": "เมื่อผู้ฝากขอ"
  },
  "form": {
    "profile": "รายละเอียด",
    "displayName": "ชื่อที่แสดง",
    "displayName_hint": "ชื่อที่พนักงานและพอร์ทัลใช้เรียก",
    "legalName": "ชื่อ-นามสกุลจริง",
    "legalName_hint": "ตามบัตรประจำตัว (สำหรับ 古物台帳)",
    "nameKana": "ชื่อ (คานะ)",
    "email": "อีเมล",
    "phone": "โทรศัพท์",
    "locale": "ภาษา",
    "address": "ที่อยู่",
    "postalCode": "รหัสไปรษณีย์",
    "region": "จังหวัด (都道府県)",
    "city": "เมือง",
    "address1": "บ้านเลขที่/ถนน",
    "address2": "อาคาร/ห้อง",
    "payoutMethod": "รับเงินทางไหน?",
    "commission": "ค่าคอมของร้าน",
    "commission_hint": "เว้นว่าง = ใช้กฎปกติของร้าน",
    "payoutSchedule": "รอบการจ่าย",
    "minPayout": "ยอดจ่ายขั้นต่ำ",
    "minPayout_hint": "ยอดที่น้อยกว่านี้รอจ่ายรอบหน้า",
    "feePolicy": "ค่าธรรมเนียมบัตร (เมื่อผู้ซื้อจ่ายด้วยบัตร)",
    "invoiceRegistered": "จดทะเบียนインボイスแล้ว (มี 登録番号)",
    "taxId": "登録番号",
    "taxId_hint": "T ตามด้วยตัวเลข 13 หลัก เช่น T1234567890123",
    "baikaisha_note": "ผู้ฝากที่จดทะเบียนแล้ว: ร้านออกใบกำกับแทนได้ (媒介者交付特例) ⚠️ ยืนยันวิธีใช้กับ 税理士",
    "notes": "หมายเหตุ (เฉพาะพนักงาน)",
    "save": "บันทึกรายละเอียด",
    "saved": "บันทึกรายละเอียดแล้ว",
    "stale": "มีคนเพิ่งแก้ข้อมูลผู้ฝากนี้ เปิดใหม่อีกครั้ง"
  },
  "problems": {
    "display_name": "เขียนชื่อ",
    "email": "อีเมลดูไม่ถูกต้อง",
    "commission": "เปอร์เซ็นต์ระหว่าง 0 ถึง 100",
    "tax_id": "T ตามด้วยตัวเลข 13 หลัก",
    "min_payout": "เยนเต็มจำนวน",
    "fix": "แก้ช่องสีแดงก่อน"
  },
  "bank": {
    "title": "บัญชีรับเงิน",
    "none": "ยังไม่มีบัญชี",
    "add": "เพิ่มบัญชี",
    "change": "ใส่บัญชีใหม่",
    "description": "ใส่บัญชีให้ครบ ระบบเก็บแบบเข้ารหัส หลังจากนี้พนักงานเห็นแค่ตัวเลขท้าย",
    "later": "จ่ายด้วยการโอนต้องมีบัญชี ถ้ายังไม่มี ให้เลือกเงินสดหรือเครดิตร้านไปก่อน",
    "bankName": "ธนาคาร",
    "branchCode": "เลขสาขา",
    "branch_hint": "3 หลัก (ゆうちょ ดูในสมุดบัญชี)",
    "accountNumber": "เลขบัญชี",
    "holderKana": "ชื่อบัญชี (คานะ)",
    "accountType": "ประเภทบัญชี",
    "save": "บันทึกบัญชี",
    "saved": "บันทึกบัญชีแล้ว",
    "incomplete": "กรอกบัญชีให้ครบทุกช่อง (ตัวเลขเท่านั้น) หรือเว้นว่างทั้งหมด",
    "required": "จ่ายด้วยการโอนต้องมีบัญชี — กรอกบัญชี หรือเลือกเงินสด/เครดิตร้าน"
  },
  "kpi": {
    "active": "การ์ดที่ฝากอยู่",
    "sold": "ขายแล้ว",
    "awaiting": "ค้างจ่าย",
    "paid": "จ่ายไปแล้ว"
  },
  "stages": {
    "received": "รับแล้ว",
    "under_review": "กำลังตรวจ",
    "ready_to_list": "พร้อมขาย",
    "listed": "วางขาย",
    "reserved": "อยู่ในออเดอร์",
    "paused": "พักไว้",
    "sold": "ขายแล้ว",
    "return_in_progress": "กำลังคืน",
    "returned": "คืนแล้ว",
    "closed": "เสร็จ"
  },
  "link": {
    "title": "การเข้าสู่พอร์ทัล",
    "open": "เปิดบัญชีลูกค้า",
    "email": "อีเมลสำหรับพอร์ทัล",
    "hint": "ผู้ฝากใช้อีเมลนี้ดูการ์ดและยอดรับเงินของตัวเอง",
    "send_invite": "ส่งอีเมลเชิญ",
    "submit": "ผูกบัญชี",
    "created": "สร้างและผูกบัญชีแล้ว",
    "linked": "ผูกบัญชีแล้ว",
    "invited": "ส่งคำเชิญไปที่ {{email}} แล้ว"
  },
  "status_change": {
    "needs_kyc": "ทำ 本人確認 ก่อน",
    "to": {
      "active": "เปิดใช้งาน",
      "suspended": "พักไว้",
      "closed": "ปิด",
      "pending_verification": "กลับไปรอตรวจ"
    },
    "title": {
      "active": "เปิดใช้งานผู้ฝากนี้?",
      "suspended": "พักผู้ฝากนี้?",
      "closed": "ปิดผู้ฝากนี้?",
      "pending_verification": "กลับไปรอตรวจ?"
    },
    "consequence": {
      "active": "รับการ์ดและขายได้",
      "suspended": "ไม่รับการ์ดใหม่ การ์ดที่วางขายอยู่ยังขายต่อ",
      "closed": "ไม่รับการ์ดใหม่ การ์ดที่ร้านเก็บอยู่ต้องขายหรือคืนก่อน",
      "pending_verification": "ไม่รับการ์ดจนกว่าจะทำ 本人確認 เสร็จ"
    },
    "done": {
      "active": "เปิดใช้งานผู้ฝากแล้ว",
      "suspended": "พักผู้ฝากแล้ว",
      "closed": "ปิดผู้ฝากแล้ว",
      "pending_verification": "กลับไปรอตรวจแล้ว"
    }
  },
  "agreement": {
    "title": "สัญญาฝากขาย",
    "accepted": "ลงชื่อแล้ว (ฉบับที่ {{version}})",
    "missing": "ยังไม่ลงชื่อ — รับการ์ดไม่ได้",
    "record": "ผู้ฝากลงชื่อฉบับที่ {{version}} แล้ว",
    "record_title": "บันทึกสัญญาที่ลงชื่อแล้ว?",
    "record_consequence": "เฉพาะเมื่อผู้ฝากลงชื่อสัญญากระดาษที่ร้านแล้ว",
    "record_confirm": "บันทึก",
    "recorded": "บันทึกสัญญาแล้ว",
    "open_pdf": "เปิดสัญญาที่ลงชื่อแล้ว"
  },
  "view_as": {
    "button": "ดูในฐานะผู้ฝาก",
    "opened": "เปิดพอร์ทัลของผู้ฝากในแท็บใหม่แล้ว",
    "hint": "ดูอย่างเดียว 15 นาที มีการบันทึก"
  },
  "detail": {
    "back": "ผู้ฝากทั้งหมด",
    "load_failed": "เปิดข้อมูลผู้ฝากไม่ได้",
    "status_reason": "เหตุผล:",
    "privacy": "เลขบัญชีและเลขบัตรเก็บแบบเข้ารหัส ทุกครั้งที่ดูจะถูกบันทึก",
    "take_in": "รับของฝากขาย",
    "their_cards": "การ์ดของคนนี้",
    "their_sales": "ยอดขายของคนนี้",
    "pay_now": "จ่ายเงินตอนนี้"
  },
  "new": {
    "title": "ผู้ฝากใหม่",
    "intro": "ใส่ข้อมูลไม่กี่ช่อง แล้วทำ 本人確認 ต่อทันที",
    "save": "บันทึกแล้วทำ 本人確認",
    "created": "สร้าง {{reference}} แล้ว",
    "created_hint": "ต่อไปคือ 本人確認"
  },
  "masked": {
    "show": "แสดง",
    "hide": "ซ่อน ({{seconds}} วิ)",
    "recorded": "การดูครั้งนี้ถูกบันทึก จะซ่อนเองใน 30 วินาที"
  },
  "address": {
    "postalCode": "รหัสไปรษณีย์",
    "region": "จังหวัด (都道府県)",
    "city": "เมือง",
    "address1": "บ้านเลขที่/ถนน",
    "address2": "อาคาร/ห้อง",
    "country": "ประเทศ",
    "postal_hint": "ใส่ 7 หลักแล้วที่เหลือจะเติมให้",
    "postal_found": "เติมที่อยู่แล้ว — เพิ่มบ้านเลขที่",
    "postal_unknown": "ไม่พบรหัสไปรษณีย์นี้ — พิมพ์ที่อยู่เอง"
  },
  "kyc": {
    "title": "本人確認 (ยืนยันตัวตน)",
    "state": {
      "verified": "✅ ยืนยันแล้ว",
      "expired": "⚠️ หมดอายุ — ตรวจใหม่",
      "pending": "รอตรวจ",
      "rejected": "❌ ไม่ผ่าน",
      "missing": "❌ ยังไม่ทำ"
    },
    "start": "ทำ 本人確認",
    "again": "ตรวจใหม่",
    "none_body": "ยังไม่ได้ทำ รับการ์ดได้หลังทำเสร็จเท่านั้น",
    "details_hidden": "รายละเอียดบัตรแสดงเฉพาะพนักงานที่มีสิทธิ์",
    "form_title": "本人確認",
    "form_description": "ดูบัตร กรอกเฉพาะที่กฎหมายกำหนด แล้วถ่ายรูป",
    "save_verified": "ตรวจบัตรแล้ว — บันทึก",
    "save_pending": "บันทึก (ตรวจภายหลัง)",
    "saved_verified": "本人確認 เสร็จแล้ว",
    "saved_pending": "บันทึก 本人確認 แล้ว — รอตรวจ",
    "valid_until": "ใช้ได้ถึง {{day}}",
    "valid_until_label": "ใช้ได้ถึง",
    "checked": "ตรวจเมื่อ",
    "channel": "ที่ไหน",
    "channels": {
      "face_to_face": "ที่เคาน์เตอร์ (ต่อหน้า)",
      "remote": "ไม่ต่อหน้า (ไปรษณีย์/ออนไลน์)"
    },
    "method": "บัตรอะไร?",
    "methods": {
      "drivers_license": "ใบขับขี่",
      "my_number_card": "บัตร My Number",
      "passport": "พาสปอร์ต",
      "residence_card": "บัตรผู้พำนัก (在留カード)",
      "health_insurance_card": "บัตรประกันสุขภาพ",
      "other_official_id": "เอกสารราชการอื่น",
      "remote_ekyc_photo_id": "ออนไลน์: บัตรมีรูป + ใบหน้า",
      "remote_ic_chip": "ออนไลน์: ชิป IC ของบัตร",
      "remote_my_number_signature": "ออนไลน์: ลายเซ็น My Number",
      "remote_seal_certificate": "ใบรับรองตราประทับทางไปรษณีย์",
      "remote_honnin_gentei_mail": "本人限定受取郵便",
      "remote_juminhyo_registered_mail": "住民票 + ไปรษณีย์ลงทะเบียน",
      "remote_juminhyo_same_name_transfer": "住民票 + โอนเข้าบัญชีชื่อเดียวกัน",
      "remote_id_copy_registered_mail_transfer": "สำเนาบัตร + ไปรษณีย์ลงทะเบียน + โอน",
      "remote_two_ids_delivery_record": "บัตร 2 ใบ + หลักฐานการส่ง",
      "remote_returning_customer_credential": "ลูกค้าเดิม (เคยตรวจแล้ว)",
      "remote_other_rule15_3": "อื่นๆ (ข้อ 15-3)"
    },
    "document_number_hint": "เก็บแบบเข้ารหัส หลังจากนี้แสดงแค่ 4 ตัวท้าย",
    "fields": {
      "full_name": "ชื่อ-นามสกุล",
      "name_kana": "ชื่อ (คานะ)",
      "address": "ที่อยู่",
      "occupation": "อาชีพ",
      "date_of_birth": "วันเกิด",
      "picture": "รูปบัตร",
      "document_number": "เลขบัตร",
      "document_expiry": "บัตรหมดอายุ"
    },
    "occupations": {
      "employee": "会社員",
      "self_employed": "自営業",
      "student": "学生",
      "homemaker": "主婦・主夫",
      "none": "無職"
    },
    "age": "อายุ: {{age}} ปี",
    "age_at_check": "อายุตอนตรวจ",
    "dob_hint": "ระบบคำนวณอายุจากวันเกิด",
    "minor_title": "อายุต่ำกว่า 18 ({{age}} ปี)",
    "minor_body": "แนบหนังสือยินยอมของผู้ปกครอง (青少年条例) — ถ้าไม่มีจะบันทึกไม่ได้",
    "minor_blocked_body": "ร้านไม่รับการ์ดจากผู้ที่อายุต่ำกว่า 18",
    "minor_short": "ต่ำกว่า 18",
    "guardian_consent": "หนังสือยินยอมผู้ปกครอง (รูป)",
    "picture_front": "บัตร — ด้านหน้า",
    "picture_back": "บัตร — ด้านหลัง (ถ้าจำเป็น)",
    "picture_alt": "รูปบัตร {{n}}",
    "show_picture": "แสดงรูป {{n}}",
    "hide_picture": "ซ่อน",
    "no_pictures": "ไม่มีรูป",
    "privacy": "รูปเก็บแบบเข้ารหัส และเก็บเฉพาะเวลาที่กฎหมายกำหนด (3 ปี)",
    "blocker": {
      "minor_blocked": "อายุต่ำกว่า 18: ร้านไม่รับ",
      "blocked": "รับการตรวจนี้ไม่ได้ (กฎของร้าน)",
      "minor_consent": "อายุต่ำกว่า 18: แนบหนังสือยินยอมของผู้ปกครองก่อน",
      "missing": "ยังขาด: {{fields}}",
      "uploading": "รอให้อัปโหลดรูปเสร็จก่อน"
    },
    "verify": "ยืนยันว่าตรวจแล้ว",
    "verified": "ยืนยัน 本人確認 แล้ว",
    "reject": "ไม่ผ่าน",
    "rejected": "本人確認 ไม่ผ่าน",
    "reject_title": "ให้การตรวจนี้ไม่ผ่าน?",
    "reject_consequence": "ผู้ฝากต้องแสดงบัตรใหม่ เขียนเหตุผล",
    "reject_reason": "เหตุผลที่ไม่ผ่าน"
  }
}
